module.exports = __webpack_public_path__ + "media/images/lb/102-c97070bd5ceb55a68156e4161555ba6f.svg";